var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _path, _circle2, _circle3, _rect6, _rect7, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSemiDetachedHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 56,
    r: 5,
    fill: "#D4D5FC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 49,
    width: 14,
    height: 23,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 49,
    width: 14,
    height: 23,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 40,
    width: 68,
    height: 6,
    fill: "#D4D5FC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 28,
    width: 12,
    height: 10,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 28,
    width: 12,
    height: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8 13H64.2L73 26H7L15.8 13Z",
    fill: "#8D84F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 59.5,
    r: 1.5,
    fill: "#5B53B5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 59.5,
    r: 1.5,
    fill: "#5B53B5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 30,
    width: 8,
    height: 3,
    fill: "#D4D5FC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 30,
    width: 8,
    height: 3,
    fill: "#D4D5FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 61C43.7614 61 46 58.7614 46 56C46 53.2386 43.7614 51 41 51C38.2386 51 36 53.2386 36 56C36 58.7614 38.2386 61 41 61ZM41 59C42.6569 59 44 57.6569 44 56C44 54.3431 42.6569 53 41 53C39.3431 53 38 54.3431 38 56C38 57.6569 39.3431 59 41 59Z",
    fill: "#231C70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 28V38H31V28H19ZM29 30H21V36H29V30Z",
    fill: "#231C70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 28V38H61V28H49ZM59 30H51V36H59V30Z",
    fill: "#231C70"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 26H10V40H6V46H10V70H7C6.44772 70 6 70.4477 6 71C6 71.5523 6.44772 72 7 72L73 72C73.5523 72 74 71.5523 74 71C74 70.4477 73.5523 70 73 70H70V46H74V40H70V26H73L64.2 13H15.8L7 26ZM68 70V46H12V70H19V49H33V70H49V49H63V70H68ZM61 70V51H51V70H61ZM31 70V51H21V70H31ZM16.8613 15L10.769 24H69.231L63.1387 15H16.8613ZM68 40V26H12V40H68ZM72 42H8V44H72V42Z",
    fill: "#231C70"
  })));
}
export default SvgSemiDetachedHouse;